export default {
  loading: false,
  accessToken: localStorage.getItem('accessToken'),
  refreshToken: localStorage.getItem('refreshToken'),
  expiration: localStorage.getItem('expiration'),
  loadingAccessToken: false,
  user: localStorage.getItem('user'),
  language: localStorage.getItem('language') ? localStorage.getItem('language') : 'rs',
  currencies: localStorage.getItem('currencies') ? localStorage.getItem('currencies') : 'eur',
  tableScrollPosition: null,
  cookieAccept: localStorage.getItem('cookieAccept') ? localStorage.getItem('cookieAccept') : false
}



// WEBPACK FOOTER //
// ./src/store/state.js